import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BsBoxArrowInUpRight } from 'react-icons/bs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ALL from './components/ALL';

const Vendors = () => {
  const navigate = useNavigate();

  return (
    <div>
      {' '}
      <div className="d-flex align-items-center">
        <div
          aria-hidden="true"
          className="view-all-btn ms-auto text-decoration-none text-nowrap"
          onClick={() => navigate('/vendors')}
        >
          View All <BsBoxArrowInUpRight />
        </div>
      </div>
      <ErrorBoundary>
        <ALL />
      </ErrorBoundary>
    </div>
  );
};

export default Vendors;
